document.addEventListener("DOMContentLoaded", function () {

  var queryString = window.location.search;
  if (!queryString) return;

  var buttons = document.querySelectorAll(".lp-button-react");

  for (var i = 0; i < buttons.length; i++) {
    var el = buttons[i];
    var href = el.getAttribute("href");

    if (!href) continue;

    try {
      var url = new URL(href, window.location.origin);

      // merge query params (existing + current page)
      var currentParams = new URLSearchParams(queryString);
      var targetParams = new URLSearchParams(url.search);

      currentParams.forEach(function (value, key) {
        targetParams.set(key, value);
      });

      url.search = targetParams.toString();

      el.setAttribute("href", url.toString());

    } catch (e) {
      console.warn("Invalid URL on element:", href);
    }
  }

});